import React, { Component } from 'react';
import { connect } from '@common/components/base.component';
import autoBind from 'react-autobind';
import { ddados } from "../solicitarDocumento.ddados";
import api from '../service/solicitarDocumento.service';
import DDadosItem from '@common/components/ddados/ddados.item';

class Container extends Component {
  constructor(props) {
    super(props, ddados);
    autoBind(this);
  }

  render() {
    const { onChange, state, isView, obrigatorio} = this.props;
    const { Campos } = ddados;

    return (
      <div>
        <DDadosItem
          name="SuggestionSolicitarDocumento"
          {...Campos.SolicitarDocumentoSuggestion}
          service={api.suggestionSolicitarDocumento}
          mapItem={item => ({ ...item, Exibicao: item.Descricao })}
          mapLookupItem={item => ({
            ...item,
            Exibicao: item.Id + ' - ' + item.TipoDocumento,
          })}
          lookup={false}
          obrigatorio={obrigatorio}
          isView={isView}
          state={state}
          onChange={onChange}
          {...this.props}
        />
      </div>
    );
  }
}

export default connect({})(Container);
